module.exports = __webpack_public_path__ + "img/chinesecompany40.5bb6f681.png";